import { isEmpty, isNumber } from 'lodash'

export default {
    data() {
        return {
            frequencyRanges: [
                { min: 406, max: 419.99999, value: 'UHF: 406-<420MHz', isAdvanced: false },
                { min: 420, max: 450, value: 'UHF: 420-450MHz', isAdvanced: false },
                { min: 445, max: 480, value: 'UHF: 445-480MHz', isAdvanced: false },
                { min: 142, max: 175, value: 'VHF: 142-175MHz', isAdvanced: false },
                { min: 0, max: 0, value: 'Advanced', isAdvanced: true },
            ],
            chosenFrequencyRangeIndex: 2,
            allowAdvancedFrequencies: false,
        }
    },

    computed: {
        allowableFrequencyRanges() {
            return this.frequencyRanges.filter((range) => !range.isAdvanced || this.allowAdvancedFrequencies)
        },
    },

    methods: {
        channelOutOfRange(channel) {
            if (isEmpty(channel.frequency)) {
                return false
            }

            if (this.chosenRangeIsAdvanced()) {
                return (
                    this.frequencyRanges.findIndex((range) => {
                        return !range.isAdvanced && this.isWithinRange(channel, range)
                    }) === -1
                )
            }

            const currentFrequencyRange = this.frequencyRanges[this.chosenFrequencyRangeIndex]

            return !this.isWithinRange(channel, currentFrequencyRange)
        },

        anyChannelOutOfRange() {
            const allChannels = this.controlChannels.concat(this.dataChannels)
            for (let i = 0; i < allChannels.length; i++) {
                if (this.channelOutOfRange(allChannels[i])) {
                    return true
                }
            }
            return false
        },

        chosenRangeIsAdvanced() {
            return this.frequencyRanges[this.chosenFrequencyRangeIndex]?.isAdvanced
        },

        isWithinRange(channel, range) {
            const freq = Number(channel.frequency)
            return isNumber(freq) && freq >= range.min && freq <= range.max
        },

        /**
         * Return index of the first range that the given channels fall into.
         * If nothing is found, return "Advanced" range (aka final range in list).
         */
        findFrequencyRangeIndex(channels) {
            // Search in reverse order, as bottom ranges have priority if there is overlap
            const frequencyRangesReversed = this.frequencyRanges.slice().reverse()
            const foundRangeIndex = frequencyRangesReversed.findIndex((range) => {
                return channels.every((channel) => {
                    return this.isWithinRange(channel, range)
                })
            })

            // If no specific range found for all channels, just go to Advanced
            if (foundRangeIndex === -1) {
                return this.frequencyRanges.findIndex((range) => {
                    return range.isAdvanced
                })
            }

            return this.frequencyRanges.length - foundRangeIndex - 1
        },
    },
}
